<template>
<div>
  <Tabs :animated="false" type="card">
    <TabPane label="签约人信息">
      <singer-info @showimg="showImg" :signPeopleInfo ="signPeopleInfo"></singer-info>
    </TabPane>
    <TabPane label="合同信息">
      <contract-info :contractInfo = "contractInfo"></contract-info>
    </TabPane>
    <TabPane label="账单信息">
      <bill :billInfo="billInfo"></bill>
    </TabPane>
    <TabPane label="交割信息">
      <delivery @showimg = "showImg" :deliverysInfo="deliverysInfo" ></delivery>
    </TabPane>
    <div slot="extra">
      <a v-if="contractInfo && contractInfo.contractFilePath" class="tab-right" target="_blank" :href="contractInfo.contractFilePath">合同文本查看</a>
      <a href="javascript:void(0);" class="tab-right"  @click="showProHander">补充协议查看</a>
      <Upload
              :before-upload="beforeUpload"
              :headers="setHeaders"
              :action="baseUrl+'/contract/uploadSupplyProtocol'"
              :data="getData"
              :show-upload-list="false"
              :on-success="uploadSuccess">
        <a href="javascript:;"  class="tab-right">上传</a>
      </Upload>
    </div>
  </Tabs>
  <img-show :n="showImgKey" :src="imgSrc"></img-show>
  <!--:value.sync="showPro"-->
  <protocol-list

   v-model="showPro"
    :contractFid="getData"></protocol-list>
</div>
</template>

<script type="text/ecmascript-6">
import { contractSignPeopleInfo, personalContractInfo, personalBillList, personalDeliveryInfo, getSupplyProtocolList } from 'api/auditContract'
import SingerInfo from './components/SingerInfo'
import ContractInfo from './components/ContractInfo'
import Bill from './components/Bill'
import Delivery from './components/PersonalDeliveryInfo'
import ImgShow from 'components/ImgShow/index'
import ZUpload from '@/components/upload/index';
import ProtocolList from '../components/ProtocolList';
import { getToken } from '@/utils/auth.js';
import {getBaseUrl} from "@/utils/public";


export default {
  name:'personalcontractdetail',
  created(){
    this.contractId = this.$route.query.id
    this.contractCode = this.$route.query.code
    this.baseUrl = getBaseUrl()
    this.initData()
  },
  activated(){
    if(this.isActived){
      this.contractId = this.$route.query.id
      this.contractCode = this.$route.query.code
      this.initData()
    }else{
      this.isActived = true
    }
  },
  computed:{
    tag() {
      return this.$store.state.tagsView.visitedViews.find(tag => {
        return tag.path===this.$route.path
      });
    },
    getData() {
      return {
        contractFid: this.$route.query.id || ''
      }
    },
    setHeaders() {
        return {'Access-Token':getToken()}
    }
  },
  components:{
    SingerInfo,
    ContractInfo,
    Bill,
    Delivery,
    ImgShow,
    ZUpload,
    ProtocolList
  },
  data () {
    return {
      isActived:false,
      isAudit:true,
      contractId:'',
      contractCode:'',
      showImgKey:0,
      imgSrc:'',
      signPeopleInfo:null,
      contractInfo:null,
      billInfo:[],
      deliverysInfo:null,
      addAgreementUrl:'',
      showPro:false,
      proList:[],
      baseUrl: "",
    };
  },
  methods:{
    showImg(data) {
      this.imgSrc = data
      this.showImgKey++
    },
    initData(){
      contractSignPeopleInfo(this.contractId).then( res => {
        this.signPeopleInfo = res.data
      })
      personalContractInfo(this.contractId).then( res => {
        this.contractInfo = res.data;
        this.addAgreementUrl = res.data.contractFileSupplyPath;
      })
      personalBillList(this.contractCode).then( res => {
         this.billInfo = res.data
      })
      personalDeliveryInfo(this.contractId).then( res => {
        this.deliverysInfo = res.data
      })
    },
    uploadSuccess (res, file) {
      if (res.code == 1) {
        this.$Notice.error({
          desc: res.message,
          duration:0
        });
      } else {
        this.$Message.success('补充协议上传成功');
      }
    },
    beforeUpload (file) {
        console.log("进入beforeUpload方法")
        const isLt2M = file.size / 1024 / 1024 < 10;
        console.log(isLt2M);
        if(!isLt2M) {
            this.$Notice.error({
              desc: '上传文件大小不能大于10M,请压缩后上传' ,
              duration:0
            });
            return false;
        }
        return true;
    },
    showProHander() {
      this.showPro=true;
    }
  }
}
</script>
<style lang="css" scoped>
.tab-right{
  padding: 8px 16px 16px;
}
</style>
